<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><strong>CONTENTS </strong></h2>
<h6 class="P29"><span href="#/html/cover" title="Link target outside of Sample">Cover</span></h6>
<h6 class="P29"><span href="#/html/03_Copyrigh" title="Link target outside of Sample">Copyright</span></h6>
<h6 class="P29"><a href="#/html/05_Acknowle#id0">Acknowledgments</a></h6>
<h6 class="image"><img alt="Image" src="html/images/commn.jpg"/></h6>
<h6 class="P29"><a href="#/html/06_THE_GOLD">1 THE GOLDEN TICKET </a></h6>
<h6 class="P29"><span href="#/html/07_LION_HUN" title="Link target outside of Sample">2 LION HUNTING IN SCOTLAND </span></h6>
<h6 class="P29"><span href="#/html/08_PANTING#id7" title="Link target outside of Sample">3 PANTING UP THE ENDLESS ALP OF LIFE </span></h6>
<h6 class="P29"><span href="#/html/09_SEETHING" title="Link target outside of Sample">4 SEETHING IN YORKSHIRE </span></h6>
<h6 class="P29"><span href="#/html/10_OH_FOR_A" title="Link target outside of Sample">5 OH FOR A MUSE OF FIRE! </span></h6>
<h6 class="P29"><span href="#/html/11_FREUD__A" title="Link target outside of Sample">6 FREUD, ACTUALLY </span></h6>
<h6 class="image"><img alt="Image" src="html/images/commn.jpg"/></h6>
<h6 class="P29"><span href="#/html/12_HOW_TO_G" title="Link target outside of Sample">How to Get There </span></h6>
<h6 class="P29"><span href="#/html/13_FURTHER#id9" title="Link target outside of Sample">Further Reading </span></h6>
<h6 class="P29"><span href="#/html/14_PHOTO_CR" title="Link target outside of Sample">Photo Credits </span></h6>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?8020f3d8